import api from '../utils/api'
import { API_ROOT } from '../constants'

/**
 * Fetch all spaces for the current user
 */
export const listSpaces = async (config = {}) => {
  return await api.get(`${API_ROOT}/v3/spaces/list`, {}, config.headers, config)
}

export const createSpace = async (data, config = {}) => {
  const { name, sortOrder = 0, isPrivate = false } = data

  if (!name || !name.trim()) {
    throw new Error('Space name is required')
  }

  if (name.trim().length > 25) {
    throw new Error('Space name cannot exceed 25 characters')
  }

  return await api.post(
    `${API_ROOT}/v3/spaces/create`,
    {
      name: name.trim(),
      sortOrder,
      isPrivate
    },
    config.headers
  )
}

/**
 * Update an existing space
 * @param {string} spaceId - Space ID
 * @param {Object} data - Updated space data
 * @param {string} data.name - Space name (optional)
 * @param {number} data.sortOrder - Sort order (optional)
 * @param {Object} config - Request configuration
 */
export const updateSpace = async (spaceId, data, config = {}) => {
  if (!spaceId) {
    throw new Error('Space ID is required')
  }

  const updateData = {}
  if (data.name !== undefined) {
    if (!data.name.trim()) {
      throw new Error('Space name cannot be empty')
    }
    if (data.name.trim().length > 25) {
      throw new Error('Space name cannot exceed 25 characters')
    }
    updateData.name = data.name.trim()
  }

  if (data.sortOrder !== undefined) {
    updateData.sortOrder = data.sortOrder
  }

  if (data.isPrivate !== undefined) {
    updateData.isPrivate = data.isPrivate
  }

  return await api.put(`${API_ROOT}/v3/spaces/${spaceId}/update`, updateData, config.headers)
}

/**
 * Delete a space
 * @param {string} spaceId - Space ID
 * @param {Object} config - Request configuration
 */
export const deleteSpace = async (spaceId, config = {}) => {
  if (!spaceId) {
    throw new Error('Space ID is required')
  }

  return await api.delete(`${API_ROOT}/v3/spaces/${spaceId}/delete`, {}, config.headers, config)
}

/**
 * Assign a site to a space
 * @param {Object} data - Assignment data
 * @param {string} data.subdomain - Site subdomain (required)
 * @param {string} data.spaceId - Space ID (optional, null to unassign)
 * @param {Object} config - Request configuration
 */
export const assignSiteToSpace = async (data, config = {}) => {
  const { subdomain, spaceId } = data

  if (!subdomain) {
    throw new Error('Subdomain is required')
  }

  return await api.put(
    `${API_ROOT}/v3/spaces/assign-site`,
    {
      subdomain,
      spaceId: spaceId || null
    },
    config.headers
  )
}
